export default __webpack_public_path__ + "3721ef7f25dbf0f6c53b897a819b2a95.svg";